export default "__VITE_ASSET__BxRkEU8O__"